import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import SecurityIcon from "@mui/icons-material/Security";
import { Button } from "@mui/material";
import { useState } from "react";
import Flex from "../../../../../components/Flex";
import Text from "../../../../../components/Text";
import CustomTabs from "../../../../../components/app/CustomTabs";
import ProviderUserModal from "../../../../../components/app/admin/provider-groups/ProviderUserDrawer";
import UpsertStaffUserDrawer from "../../../../../components/app/admin/provider-groups/UpsertStaffUserDrawer";
import { STATE_LIST } from "../../../../../constants";
import { ProviderUserType } from "../../../../../constants/ProviderUserSchema";
import { PartialCustomTabData } from "../../../../../constants/constant-types";
import { appPaths } from "../../../../../constants/paths";
import useCurrentUser from "../../../../../hooks/local-storage/use-current-user";
import { useReduceDisclosure } from "../../../../../hooks/use-reduce-disclosure";
import { useProviderProfile } from "../../../../../queries/provider/setting/use-provider-profile";
import { useGetUserDetail } from "../../../../../queries/use-get-pertiCular-user";
import { useUpdateProviderUser } from "../../../../../queries/use-update-provider-user";
import { useUpdateUser } from "../../../../../queries/use-update-user";
import {
  DEFAULT_UUID_NAME_LIST,
  DEFAULT_VALUE_LABEL_LIST,
  getUnNecessaryTransformData,
  getXtenantId,
  transformMultiSelectFrontEndVal,
} from "../../../../../utils/utils";
import UserProfile from "../../../admin/UserProfile";
import ProviderProfileFullView from "../../ProfileProfileFullView";
// import NotificationTable from "./NotificationTable";
import { useUpdateLocalStorageForCurrentProvider } from "../../../../../hooks/local-storage/useUpdateLocalStorageForCurrentProvider";
import EnableDisableAuth from "./TwoFAMethods/EnableDisableAuth";
import { TWO_FA_METHODS } from "./TwoFAMethods/constant";
import TwoFAauth from "./TwoFAauth";
const TABS: PartialCustomTabData[] = [
  {
    value: "profile",
    path: appPaths.libraryCatalogLOINCCodePath,
    label: "Profile",
  },
  // {
  //   value: "provider_group",
  //   path: appPaths.libraryCatalogDrugCatalogPath,
  //   label: "Provider Group",
  // },
  // {
  //   value: "notification",
  //   path: appPaths.libraryCatalogICDTenCodePath,
  //   label: "Notification",
  // },
  {
    value: "twoFactorAuth",
    path: appPaths.twoFactorAuth,
    label: "2FA Security",
  },
];

const AccountSettings = () => {
  const [activeButton, setActiveButton] = useState<string>(TABS[0].value);
  const [
    editProviderGroupDisclosure,
    providerUserDisclosure,
    staffUserDisclosure,
    twoFactorAuthDisclosure,
  ] = useReduceDisclosure(4);
  // const { mutateAsync: ChangeProviderGroupAvatar } =
  //   useChangeProviderGroupAvatar();
  // const { mutateAsync: editProviderGroupProfile } =
  //   useEditProviderGroupProfile();

  // function onEditProviderGroupSubmit(values: ProviderGroup) {
  //   return editProviderGroupProfile({
  //     providerGroup: {
  //       ...getUnNecessaryTransformData(
  //         ["specialities", "acceptedInsurances"],
  //         values
  //       ),
  //       uuid: providerGroupUuid,
  //     },
  //   }).then((res) => {
  //     if (values.avatar && !values?.avatar?.includes(".amazonaws.com")) {
  //       return ChangeProviderGroupAvatar({
  //         providerGroupId: values.uuid ?? "",
  //         avatar: {
  //           newAvatar: values.avatar,
  //         },
  //       });
  //     }
  //     return res;
  //   });
  // }

  const { mutateAsync: updateProviderUser } = useUpdateProviderUser();
  const [me] = useCurrentUser();

  function editProviderUser(values: ProviderUserType) {
    const payLoad = getUnNecessaryTransformData(
      ["licensedStates", "specialities", "acceptedInsurances", "workLocations"],
      values
    ) as any;
    return updateProviderUser({
      providerData: payLoad,
      xTENANTID: getXtenantId() ?? "",
    }).then((res) => {
      refetch();
      // isProviderUpdate.current = true;
      enableProviderUpdate();
      return res;
    });
  }
  // const viewAs = localStorage.getItem("viewAs");

  // const { data: providerGroupList } = useProviderGroupList({
  //   pagination: {
  //     page: 0,
  //     pageSize: 10,
  //   },
  //   xTENANTID: viewAs === "provider" ? realm ?? undefined : undefined,
  // });
  // const providerGroupUuid = providerGroupList?.content?.[0]?.uuid;

  // const { data: profileData }: any = useProviderGroupProfile(providerGroupUuid);
  const { data: ProviderProfileData, refetch }: any = useProviderProfile(
    getXtenantId() ?? undefined,
    true
  );

  const { data: staffUserProfile, refetch: refetchUserProfile } =
    useGetUserDetail({
      userId: me?.uuid,
      xTENANTID: getXtenantId() ?? undefined,
      disable: me?.roleType !== "STAFF",
    });

  const userData = ProviderProfileData?.data;
  const { enableProviderUpdate } =
    useUpdateLocalStorageForCurrentProvider(userData);

  const handleUserProfileClick = () => {
    if (activeButton === "profile") {
      return me?.roleType === "STAFF"
        ? staffUserDisclosure.open()
        : providerUserDisclosure.open();
    }

    // handle the provider group edit profile
    editProviderGroupDisclosure.open();
  };
  const { mutateAsync: updateStaffUser } = useUpdateUser();

  const editStaffUser = (values: any) => {
    const transFormData: any = getUnNecessaryTransformData(
      ["workLocations"],
      values
    );
    return updateStaffUser({
      user: transFormData,
      xTENANTID: getXtenantId() ?? undefined,
    }).then((res) => {
      refetchUserProfile();
      return res;
    });
  };

  return (
    <Flex flexDirection={"column"} gap={"10px"}>
      <Flex justifyContent={"space-between"} gap={1} mb={"10px"}>
        <CustomTabs
          tabsData={TABS}
          value={activeButton}
          onChange={setActiveButton}
        />

        {activeButton === "profile" && (
          <Flex alignItems={"center"}>
            <Button
              startIcon={<ModeEditOutlineOutlinedIcon />}
              variant="outlined"
              onClick={handleUserProfileClick}
            >
              Edit Profile
            </Button>
          </Flex>
        )}

        {activeButton === "twoFactorAuth" && (
          <Flex alignItems={"center"}>
            <Text>{me?.twoFAEnabled ? "2FA Enabled" : "2FA Disabled"}</Text>
            <Text>
              {" "}
              {`(${
                TWO_FA_METHODS[me?.twoFAType as keyof typeof TWO_FA_METHODS] ??
                "None"
              })`}
            </Text>
            <Button
              startIcon={<SecurityIcon />}
              sx={{
                marginLeft: "10px",
              }}
              variant="outlined"
              onClick={() => {
                twoFactorAuthDisclosure.open();
              }}
            >
              {me?.twoFAEnabled ? "Disable 2FA" : "Enable 2FA"}
            </Button>
          </Flex>
        )}
      </Flex>

      {/* <ProviderGroupDrawer
        openProviderForm={editProviderGroupDisclosure.opened}
        handleClose={editProviderGroupDisclosure.close}
        title="Edit Provider Group Profile"
        onSubmit={onEditProviderGroupSubmit}
        prefillValues={
          {
            ...profileData,
            acceptedInsurances: transformMultiSelectFrontEndVal(
              DEFAULT_INS_LABEL_LIST,
              profileData?.acceptedInsurances as any
            ),
            specialities: transformMultiSelectFrontEndVal(
              DEFAULT_UUID_NAME_LIST,
              profileData?.specialities as any
            ),
          } as any
        }
      /> */}

      <UpsertStaffUserDrawer
        open={staffUserDisclosure.opened}
        modalTitle="Edit User"
        onClose={staffUserDisclosure.close}
        initialValues={{
          ...staffUserProfile?.data,
          workLocations: transformMultiSelectFrontEndVal(
            DEFAULT_VALUE_LABEL_LIST,
            staffUserProfile?.data?.workLocations
          ),
        }}
        onSubmit={editStaffUser}
      />
      <ProviderUserModal
        open={providerUserDisclosure.opened}
        title={"Edit Profile"}
        onClose={providerUserDisclosure.close}
        onSubmit={editProviderUser}
        prefillValues={{
          ...(userData ?? {}),
          acceptedInsurances: transformMultiSelectFrontEndVal(
            DEFAULT_VALUE_LABEL_LIST,
            userData?.acceptedInsurances
          ),
          spokenLanguages: transformMultiSelectFrontEndVal(
            DEFAULT_UUID_NAME_LIST,
            userData?.spokenLanguages
          ),
          ageGroupSeen: transformMultiSelectFrontEndVal(
            DEFAULT_VALUE_LABEL_LIST,
            userData?.ageGroupSeen
          ),
          careService: transformMultiSelectFrontEndVal(
            DEFAULT_VALUE_LABEL_LIST,
            userData?.careService
          ),
          workLocations: transformMultiSelectFrontEndVal(
            DEFAULT_VALUE_LABEL_LIST,
            userData?.workLocations
          ),
          licensedStates: transformMultiSelectFrontEndVal(
            STATE_LIST,
            userData?.licensedStates
          ),
          specialities: transformMultiSelectFrontEndVal(
            DEFAULT_UUID_NAME_LIST,
            userData?.specialities
          ),
        }}
      />
      {activeButton === "twoFactorAuth" && <TwoFAauth />}
      <EnableDisableAuth disclosureHost={twoFactorAuthDisclosure} />
      {activeButton !== "twoFactorAuth" &&
        (activeButton === "profile" && me?.roleType === "STAFF" ? (
          <UserProfile userProfile={staffUserProfile?.data as any} />
        ) : (
          <ProviderProfileFullView providerData={userData} />
        ))}
      {/* {activeButton === "provider_group" && <ProviderGroupProfile />} */}
      {/* {activeButton === "notification" && <NotificationTable />} */}
    </Flex>
  );
};

export default AccountSettings;
